import { useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./context/OAuth/AuthContext";
import AppRoutes from "./AppRoutes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TimerProvider } from "./context/TimeContext";
import { UIProvider } from "./context/LoadingContext";
import { MetaProvider } from "./context/ExerciseMeta";
import { NotificationCountProvider } from "./context/NotificationCountContext";

const App = () => {
  return (
    <>
      <TimerProvider>
        <AuthProvider>
          <UIProvider>
            <MetaProvider>
              <NotificationCountProvider>
                <Router>
                  <AppRoutes />
                </Router>
              </NotificationCountProvider>
            </MetaProvider>
          </UIProvider>
        </AuthProvider>
      </TimerProvider>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
      />
    </>
  );
};

export default App;
